export function dataAttr(condition) {
    return condition ? true : undefined;
}
//# sourceMappingURL=dom.js.map